import Lottie from 'lottie-react';
import React from 'react';

import dataSpinner from './data/data.json';

import s from './LoaderChart.module.scss';

// Styles.

export default function LoaderChart(): JSX.Element {
  return (
    <Lottie
      className={s.wrapper}
      width={300}
      height={300}
      animationData={dataSpinner}
      loop
      autoplay
      // options={options}
      style={{ margin: '50px auto 0px' }}
    />
  );
}
